import styled from 'styled-components';
import { DragIndicator as OriginalDragIndicator } from '@mui/icons-material';

const DragIndicator = styled(OriginalDragIndicator)`
    color: ${({ theme }) => theme.gray.label};
`;

export default DragIndicator;
